import { StoresPageProps } from './stores-page.types'
import { PageContainer, PageHeader } from '@touche-lts/panel-ui/dist'
import { IconStores } from 'assets/icons'
import { StoresTable } from './stores-table'

const StoresPageComponent = (props: StoresPageProps) => {
  const {
    className,
    style,
    history: { push }
  } = props

  return (
    <PageContainer className={className} style={style}>
      <PageHeader
        navSegments={[
          {
            icon: IconStores,
            label: 'Stores',
            iconProps: { style: { marginBottom: -5 } }
          }
        ]}
        buttons={[
          {
            preset: 'primary',
            children: 'Add a new store',
            onClick: () => push('/stores/add')
          }
        ]}
      />
      <StoresTable />
    </PageContainer>
  )
}

const StoresPage = StoresPageComponent
export { StoresPage }
